import { ApidataService } from './../apidata.service';
import { Component, HostListener, Inject, PLATFORM_ID, Renderer2, AfterViewInit } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { CommonModule } from '@angular/common';
import { WebService } from '../services/web.service';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { FooterComponent } from '../footer/footer.component';
import { RouterModule } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { RecaptchaModule, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { MetaTagService } from '../meta-tag.service';
import { environment, GINConstants } from '../../environments/environments';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { ChangeDetectorRef, NgZone } from '@angular/core';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [HeaderComponent, CommonModule, HttpClientModule, FooterComponent,RouterModule,RecaptchaModule,    FormsModule,
    IconsFreeToolsComponent
  ],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.css',
  providers: [ApidataService],
})
export class ContactUsComponent implements AfterViewInit{
  public ngOnInit() {
      this.metaTagService.updateTags("Contact Us | Grammarin.com", "Discover who we are and what drives us! Learn about our mission, vision, and the values that fuel our journey to deliver excellence.", "https://www.grammarin.com/contact-us");
  }

  shouldShowButton: boolean = false;
  constructor( private cdr: ChangeDetectorRef, private httpClient: HttpClient,private metaTagService: MetaTagService) { }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  public color: string = 'black';
  public esubText: string = '';
  public esubText2: string = '';
  public ngAfterViewInit(): void {
    if (this.captchaVisible) {
      this.loadAndRenderTurnstileGetTouch();
    }
    window.scrollTo(0,0)
    $(window).scroll(function () {
      if ($(this).scrollTop() > 200) {
        $('#scroll-to-top').fadeIn('slow');
      }
      else {
        $('#scroll-to-top').fadeOut('slow');
      }
    });
    $('#scroll-to-top').click(function () {
      $("html, body").animate({ scrollTop: 0 }, 700);
      return false;
    });
  }
  public form_name: any;
  public form_lastname: any;
  public form_message: any;
  public form_email: any;
  public form_subject: any;
  captchaResponse: string;
  recaptcha_message = ""
  got_recpatcha : boolean = false;
  captchaToken: string | null = null; 
  recaptchaSiteKey = '6LcMnOsnAAAAAExxnt0IqIEq4pSha6O_vPeOsw-1';
  checkEmptyFieldsPhone(form) {
    let emptyFields = [];

    if (form.form_name === '') {
      emptyFields.push('form_name');
    }
    if (form.form_lastname === '') {
      emptyFields.push('form_lastname');
    }
    if (form.form_message === '') {
      emptyFields.push('form_message');
    }
    if (form.form_email === '') {
      emptyFields.push('form_email');
    }
    if (form.form_subject === '') {
      emptyFields.push('form_subject');
    }

    return emptyFields;
  }
  eFsubText: any;
  public eFsub: boolean = false;
  public eFsuberror: boolean = false;
  public eFormSubmission(event: any) {
    event.preventDefault();

      const headers = new HttpHeaders({
        'Authorization': environment.AuthorizationGIN,
      });
      this.httpClient.post(environment.API_URL+'/api/contactForm', { 'first_name': this.form_name, 'last_name': this.form_lastname, 'email': this.form_email, 'subject': this.form_subject, 'message': this.form_message }, { headers }).subscribe(
        (response) => {
          this.color = 'green';
          this.eFsubText = 'Form Submitted Successfully!';
          this.eFsub = true
          $("#eFsubText").show();
          setTimeout(function () {
            $("#eFsubText").hide();
          }, 3000);
          $('#form_email').val('').css("border-color", "#e7e7ec");
          $('#form_lastname').val('').css("border-color", "#e7e7ec");
          $('#form_subject').val('').css("border-color", "#e7e7ec");
          $('#form_message').val('').css("border-color", "#e7e7ec");
          $('#form_name').val('').css("border-color", "#e7e7ec");
        },
        (error) => {
          // console.error(error);
        }
      );

  }

    ////// hidden recaptcha strat for get touch

  captchaVisible: boolean = false; 
  isCaptchaVerified: boolean = false;
  recaptchaMessage: string = '';
    





    handleButtonClickGetTouch(): void {
      var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      this.eFsub = false
      this.eFsuberror = false
      $("#eFsubText").hide();
      this.form_name = $('#form_name').val();
      this.form_lastname = $('#form_lastname').val();
      this.form_email = $('#form_email').val();
      this.form_subject = $('#form_subject').val();
      this.form_message = $('#form_message').val();
      let form = {
        form_name: this.form_name,
        form_lastname: this.form_lastname,
        form_message: this.form_message,
        form_email: this.form_email,
        form_subject: this.form_subject
      };
      let emptyFields = this.checkEmptyFieldsPhone(form);
      if (emptyFields.length > 0 ) {
        this.color = '#721c24';
        this.eFsubText = 'Please provide the required fields';
        emptyFields.forEach((field) => $('#' + field).css("border-color", "red"));
        this.eFsuberror = true
        $("#eFsubText").show();
        setTimeout(function () {
          $("#eFsubText").hide();
          emptyFields.forEach((field) => $('#' + field).css("border-color", "#e7e7ec"));
          this.eFsuberror = false
        }, 3000);
        return
      }

      else if (typeof this.form_email === 'string' && reg.test(this.form_email) === false) {
        this.color = '#721c24';
        this.eFsubText = 'Please provide correct Email';
        $('#form_email').val('').css("border-color", "red");
        this.eFsuberror = true
        $("#eFsubText").show();
        setTimeout(function () {
          $("#eFsubText").hide();
          $('#form_email').css("border-color", "#e7e7ec");
          this.eFsub = false
        }, 3000);
        return
      }
      if (!this.isCaptchaVerified) {


      }

      if (this.isCaptchaVerified) {

        const dummyEvent = new Event('submit');
        this.eFormSubmission(dummyEvent);
      } else {
        if (!this.captchaVisible) {
          this.captchaVisible = true;
          this.cdr.detectChanges();
          this.loadAndRenderTurnstileGetTouch();
        } else {
          this.recaptchaMessage = 'Please complete the CAPTCHA.';
          this.color = '#721c24';
        }
      }
    }


    loadAndRenderTurnstileGetTouch(): void {
      if (typeof window['turnstile'] === 'undefined') {
        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
        script.async = true;
        script.defer = true;
        script.onload = () => this.renderTurnstileGetTouch();
        script.onerror = () => 
          // console.error('Failed to load Turnstile script.');
        document.body.appendChild(script);
      } else {
        this.renderTurnstileGetTouch();
      }
    }





  
    renderTurnstileGetTouch(): void {
      const containerElement = document.getElementById('recaptcha-container');
      if (!containerElement) {
   
        return;
      }

      window['turnstile'].render(containerElement, {
        sitekey: environment.CaptchaKey, 
        size: 'normal', 
        callback: (token: string) => this.onTurnstileSuccessGetTouch(token),
        'error-callback': () => this.onTurnstileErrorGetTouch(),
      });
      
    }

 
    onTurnstileSuccessGetTouch(token: string): void {
      // console.log('Turnstile token received:', token);
      this.captchaToken = token;
      this.isCaptchaVerified = true;
      this.captchaVisible = false;
      this.recaptchaMessage = '';
      const dummyEvent = new Event('submit');


      this.eFormSubmission(dummyEvent);
    }


    onTurnstileErrorGetTouch(): void {
      // console.error('Turnstile error occurred.');
      this.captchaToken = null;
      this.recaptchaMessage = 'CAPTCHA verification failed. Please try again.';
      this.color = '#721c24';
    }


    resetTurnstileGetTouch(): void {
      const containerElement = document.getElementById('recaptcha-container');
      if (typeof window['turnstile'] !== 'undefined') {
        window['turnstile'].reset(containerElement);
   
      } else {
     
      }
    }

 ////// hidden recaptcha strat for get touch
}
